import Welcome from './Welcome.vue';
import SignatureProcess from './SignatureProcess.vue';
import Identity from './Identity.vue';
import Success from './Successful.vue';

import messages from '@/locales/languages/tsp';

export const routes = {
  ROUTE_HOME: '/wallet',
  ROUTE_SIGNATURE_PROCESS: 'SignatureProcess',
  ROUTE_SUCCESS: 'Success',

  ROUTE_IDENTITY: 'Identity',
};

export const children = [
  // UserHome will be rendered inside User's <router-view>
  // when /user/:id is matched
  {
    name: 'Home',
    path: '/',
    component: Welcome,
    meta: {
      i18n: messages,
    },
  },
  {
    name: routes.ROUTE_IDENTITY,
    path: routes.ROUTE_IDENTITY,
    component: Identity,
    meta: {
      i18n: messages,
    },
  },
  {
    name: routes.ROUTE_SIGNATURE_PROCESS,

    path: routes.ROUTE_SIGNATURE_PROCESS,
    component: SignatureProcess,
    meta: {
      i18n: messages,
    },
  },
  {
    name: routes.ROUTE_SUCCESS,
    path: routes.ROUTE_SUCCESS,
    component: Success,
    meta: {
      i18n: messages,
    },
  },

  // ...other sub routes
];
